import React, { useEffect, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useSurveyModal } from '../../hooks/use-survey-modal';
export function SurveyModal() {
  const {
    isOpen,
    close
  } = useSurveyModal();
  // Load the embed script once
  useEffect(() => {
    if (document.getElementById('hire-advantage-form-script')) return;
    const script = document.createElement('script');
    script.src = 'https://admin.thehireadvantage.co/js/form_embed.js';
    script.async = true;
    script.id = 'hire-advantage-form-script';
    document.body.appendChild(script);
  }, []);
  // Close on Escape key
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    if (isOpen) document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, close]);
  // Prevent body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-783">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6" style={{
      backgroundColor: 'rgba(0,0,0,0.82)'
    }} onClick={e => {
      if (e.target === e.currentTarget) close();
    }} data-id="element-784">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 16
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl bg-[#1A2B4A] rounded-2xl shadow-2xl overflow-hidden flex flex-col" style={{
        border: '1px solid rgba(78,205,196,0.3)',
        maxHeight: 'calc(100dvh - 2rem)'
      }} data-id="element-785">
            {/* High-converting header */}
            <div className="relative px-4 sm:px-6 pt-4 sm:pt-6 pb-3 sm:pb-5 border-b border-white/10 overflow-hidden flex-shrink-0" data-id="element-786">
              {/* Subtle glow */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-20 bg-[#4ECDC4]/10 rounded-full blur-2xl pointer-events-none" data-id="element-787" />

              {/* Close button */}
              <button onClick={close} className="absolute top-3 right-3 sm:top-4 sm:right-4 w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors z-10" aria-label="Close" data-id="element-788">
                <XIcon className="w-4 h-4 text-white" data-id="element-789" />
              </button>

              {/* Badge */}
              <div className="flex justify-center mb-2 sm:mb-3" data-id="element-790">
                <span className="inline-flex items-center gap-1.5 bg-[#4ECDC4]/15 border border-[#4ECDC4]/30 text-[#4ECDC4] text-xs font-bold uppercase px-3 py-1 rounded-full tracking-wider" data-id="element-791">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#4ECDC4] animate-pulse" data-id="element-792" />
                  Limited Spots This Month
                </span>
              </div>

              {/* Headline */}
              <h2 className="text-white font-black text-lg sm:text-2xl text-center leading-tight pr-6" data-id="element-793">
                See If You Qualify for{' '}
                <span className="text-[#4ECDC4]" data-id="element-794">20+ Hires in 30 Days</span>
              </h2>
            </div>

            {/* Iframe — fills remaining space, scrollable */}
            <div className="w-full bg-white flex-1 min-h-0 overflow-y-auto" data-id="element-795">
              <iframe src="https://admin.thehireadvantage.co/widget/survey/GDgnFdc1ENo3L8xJqNC4" style={{
            border: 'none',
            width: '100%',
            minHeight: '600px',
            display: 'block'
          }} scrolling="no" id="GDgnFdc1ENo3L8xJqNC4" title="Get Started Survey" data-id="element-796" />
            </div>

            {/* Bottom trust bar */}
            <div className="bg-[#1A2B4A] border-t border-white/10 px-4 sm:px-6 py-3 sm:py-4 flex-shrink-0" data-id="element-797">
              <div className="flex items-center justify-center gap-3 sm:gap-6 flex-wrap mb-2 sm:mb-3" data-id="element-798">
                {['Free strategy call', 'No commitment', 'Results guaranteed'].map(item => <span key={item} className="flex items-center gap-1 sm:gap-1.5 text-[10px] sm:text-xs text-white/70" data-id="element-799">
                    <span className="text-[#4ECDC4] font-bold text-xs sm:text-sm" data-id="element-800">
                      ✓
                    </span>
                    {item}
                  </span>)}
              </div>
              {/* Money-back guarantee */}
              <div className="flex items-center justify-center gap-1.5 sm:gap-2" data-id="element-801">
                <span className="text-sm sm:text-lg" data-id="element-802">🛡️</span>
                <p className="text-white/50 text-[10px] sm:text-xs text-center" data-id="element-803">
                  <span className="text-white/80 font-semibold" data-id="element-804">
                    30-Day Money-Back Guarantee
                  </span>{' '}
                  — If we don't deliver 20+ qualified hires, you don't pay.
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}